export { default } from '@/src/features/voice-assessment/screens/VoiceAssessmentFinishScreen'
